import React, { useEffect, useState, lazy } from 'react';
import { Button } from '../UI/Button';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
interface HeroProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
  scrollToAccessPoints?: () => void;
}
export const Hero = ({
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm,
  scrollToAccessPoints
}: HeroProps) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const slides = [{
    title: 'We are retooling culture shapers with tools to help them launch their ideas, Fast!',
    description: 'Curating salon-style networking events that power ideas, retool people for growth, and curate opportunities for impact.',
    buttonText: "Join Today for ₦20,000 (Founder's Offer)",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uYUDzrQ7Ktb22QfCxayyYV/dfgs.png'
  }, {
    title: 'We are Building a High Trust Ecosystem for Culture Shapers',
    description: 'Join The Networking Salon Inner Circle — a curated community of ambitious professionals. Build meaningful relationships, polish your ideas, and unlock opportunities.',
    buttonText: "Join Today for ₦20,000 (Founder's Offer)",
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vCt2gb8pCBefdiGMq8vPjo/SAV_8449.jpg'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => (prev + 1) % slides.length);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 7000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative min-h-screen flex items-center border-b border-gray-200" data-id="element-435">
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-436">
        {slides.map((slide, index) => <div key={index} className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${currentSlide === index ? 'opacity-100' : 'opacity-0'}`} data-id="element-437">
            <img src={slide.image} alt={`The Networking Salon - Slide ${index + 1}`} className="w-full h-full object-cover grayscale" loading={index === 0 ? 'eager' : 'lazy'} style={{
          maxWidth: '100%',
          height: 'auto'
        }} data-id="element-438" />
            <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-439"></div>
          </div>)}
      </div>
      <div className="container mx-auto px-4 py-16 relative z-10" data-id="element-440">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-441">
          <div className="order-2 lg:order-1" data-id="element-442">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white" data-id="element-443">
              {currentSlide === 0 ? <>
                  We are retooling culture shapers with tools to help them
                  launch their ideas,{' '}
                  <span className="text-[#ff6b35] font-extrabold italic" data-id="element-444">
                    Fast!
                  </span>
                </> : slides[currentSlide].title}
            </h1>
            <p className="mt-6 text-xl text-gray-200" data-id="element-445">
              {slides[currentSlide].description}
            </p>
            <div className="mt-8 flex flex-wrap gap-4" data-id="element-446">
              <Button onClick={scrollToAccessPoints} data-id="element-447">
                {slides[currentSlide].buttonText}
              </Button>
            </div>
          </div>
          <div className="order-1 lg:order-2" data-id="element-448">
            <div className="h-20 lg:h-80" data-id="element-449"></div>
          </div>
        </div>
      </div>
      <button onClick={prevSlide} className="absolute left-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/20 hover:bg-white/30 rounded-full border border-white/30" aria-label="Previous slide" data-id="element-450">
        <ChevronLeft size={24} className="text-white" data-id="element-451" />
      </button>
      <button onClick={nextSlide} className="absolute right-4 top-1/2 transform -translate-y-1/2 p-2 bg-white/20 hover:bg-white/30 rounded-full border border-white/30" aria-label="Next slide" data-id="element-452">
        <ChevronRight size={24} className="text-white" data-id="element-453" />
      </button>
      <div className="absolute bottom-8 left-0 right-0 flex justify-center gap-2" data-id="element-454">
        {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-3 h-3 rounded-full border border-white ${currentSlide === index ? 'bg-white' : 'bg-white/30'}`} aria-label={`Go to slide ${index + 1}`} data-id="element-455" />)}
      </div>
    </section>;
};